import RoleSelector from './index.vue';
import ApiManager from '../core/api/index'
import type { RoleParams } from './types';

export function getRoleList(params: RoleParams) {
  const { token, displayLastLogin, displayLastRecharge, parentGameId, allowedGameIds } = params;
  return ApiManager.getInstance().user
    .getRoleInfo({
      token,
      isLastLogin: displayLastLogin ? 1 : 0,
      isLastRecharge: displayLastRecharge ? 1 : 0,
      game_id: allowedGameIds,
      parentGameId
    }, false)
};

export { RoleSelector };
export default RoleSelector;